import { RumEvent } from '@datadog/browser-rum';

// Known third-party script hosts that throw errors we don't control and can't fix.
// Match on stack host, not message - the messages are often generic (e.g. "Cannot
// read properties of null") and could otherwise mask a real app error.
const THIRD_PARTY_SCRIPT_HOSTS = ['scripts.clarity.ms'];

export const isThirdPartyScriptError = (event: RumEvent): boolean =>
    event.type === 'error' &&
    !!event.error.stack &&
    THIRD_PARTY_SCRIPT_HOSTS.some((host) => event.error.stack!.includes(host));
